import _export from '../internals/export.js';
import stringTrim from '../internals/string-trim.js';
import stringTrimForced from '../internals/string-trim-forced.js';

var $ = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced; // `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim

$({
  target: 'String',
  proto: true,
  forced: forcedStringTrimMethod('trim')
}, {
  trim: function trim() {
    return $trim(this);
  }
});
